import React  from 'react';
import Classes from "classnames";
import ListComponentProto from "./rating-proto";

export default function renderRatingGroupListHeader(id, props) {
    const { data, className } = props;

    const customField = gd.session.customFields.get(id)
    const { ratingType } = customField.params;
    const notSet = _.isNil(data.value);

    const classes = Classes(className, 'gd-field-rating-group-list-header', {
        'stars-5': !notSet && ratingType === 5,
        'stars-3': !notSet && ratingType === 3,
    });

    return (
        <div className={classes}>
            {!notSet && <ListComponentProto renderMode="list" id={id} canEdit={false} value={data.value}/>}
            {notSet && <div className="group-list-header-value">Not set</div>}
        </div>
    );
}